/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import {
  Box,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material';

import { themes, fonts } from '../../themes/themes';
import styled from '@emotion/styled';
import Compdirection from '../../themes/CompDirection';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface PropsValue {
  allSteps?: any;
  pendingWithData?: any;
  isLoading?: boolean;
  trans?: any;
  direction: any;
}

const CustomStepper = styled(Stepper)(() => ({
  '& .MuiStepLabel-iconContainer-active': {
    backgoundColor: themes.defaultSuccess,
  },
  '& .MuiStepLabel-root': {
    padding: 0,
  },
  '& .MuiStepIcon-root.Mui-active': {
    color: themes.defaultSuccess,
  },
  '& .MuiStepIcon-root.Mui-completed': {
    color: themes.defaultSuccess,
  },
  '& .MuiStepIcon-root': {
    color: themes.greyDefault_500,
  },

  '& .MuiStepLabel-label.Mui-completed': {
    color: themes.greyDefault,
    fontFamily: fonts.fontFamily,
    fontWeight: 'bold',
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: themes.blackDefault,
    fontFamily: fonts.fontFamily,
  },
  '& .MuiStepLabel-label': {
    color: themes.blackDefault,
    fontFamily: fonts.fontFamily,
  },
  '& .MuiStepConnector-line': {
    minHeight: '32px',
  },
}));

const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: themes.defaultSuccess,
      borderWidth: '0.1em',
    },
  },
}));

const HorizontalStepperForActionRequired = ({
  allSteps,
  pendingWithData,
  trans,
  direction,
}: PropsValue) => {
  const [activeStep, setActiveStep] = useState<any>();

  const Label = (props: any) => {
    return (
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontWeight: 'bold',
            fontSize: '0.82em',
            color: props?.name == 'Reject' ? themes.defaultError : '#081735',
          }}
        >
          {props?.name}
        </Typography>
        {props.approver && (
          <Typography
            variant="caption"
            style={{
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
            }}
          >
            {props?.approver ? props?.approver : ''}
          </Typography>
        )}
        <Typography
          variant="caption"
          style={{
            fontFamily: fonts.fontFamily,
            color: props?.name == 'Reject' ? themes.defaultError : '#081735',
          }}
        >
          {props?.subheader && (
            <DateField value={props?.subheader} format={baseDateFormatting} />
          )}
        </Typography>
      </Box>
    );
  };
  useEffect(() => {
    if (pendingWithData) {
      setActiveStep(allSteps?.length);
    } else {
      const active_step = allSteps?.length - 1;
      setActiveStep(active_step);
    }
  }, [allSteps, pendingWithData]);

  return (
    <Compdirection>
      <CustomStepper
        nonLinear
        activeStep={activeStep}
        connector={<QontoConnector />}
        orientation={direction}
        style={{
          color: '#8181A5',
          fontFamily: fonts.fontFamily,
          fontSize: '0.625em',
          marginTop: '1em',
        }}
      >
        <Step key={1} completed={true}>
          <StepLabel>
            <Label name={'Approved'} subheader={'s'} approver={'Approver'} />
          </StepLabel>
        </Step>
        <Step key={2} completed={true}>
          <StepLabel>
            <Label name={'Approved'} subheader={'s'} approver={'Approver'} />
          </StepLabel>
        </Step>
        <Step key={3} completed={true}>
          <StepLabel>
            <Label name={'Approved'} subheader={'s'} approver={'Approver'} />
          </StepLabel>
        </Step>
        <Step key={4} completed={true}>
          <StepLabel>
            <Label name={'Approved'} subheader={'s'} approver={'Approver'} />
          </StepLabel>
        </Step>
        <Step key={5} completed={true}>
          <StepLabel
            icon={
              <i
                className="las la-times"
                color={themes.defaultError}
                style={{
                  fontSize: '3em',
                  color: 'red',
                }}
              />
            }
          >
            <Label
              // {...labelProps}
              name={'Approved'}
              subheader={'s'}
              approver={'Approver'}
            />
          </StepLabel>
        </Step>

        {pendingWithData?.name && (
          <Step key={pendingWithData?.id} completed>
            <StepLabel
              error={true}
              icon={
                <i
                  className="las la-exclamation-triangle"
                  color={themes.defaultError}
                  style={{
                    fontSize: '3em',
                    color: themes.defaultError,
                  }}
                />
              }
            >
              <Label
                name={pendingWithData?.current_step}
                subheader={pendingWithData?.created_at}
                approver={`${trans('Pending with')}: ${pendingWithData?.name}`}
              />
            </StepLabel>
          </Step>
        )}
      </CustomStepper>
    </Compdirection>
  );
};
export default HorizontalStepperForActionRequired;
